export enum ReferralProviderId {
  COMPASS = 1,
  CARBIZ = 4,
  DISABLED = 5,
}